import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConfigurationDto } from '../../../core/models/configuration/configuration.model.dto';
import { API } from '../../../core/constants/api-endpoints';
import { ApiResponse } from '../../../core/models/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  private logoSubject = new BehaviorSubject<string | null>(null);
  logo$ = this.logoSubject.asObservable();
  constructor(private http: HttpClient) {}

  getConfiguration(): Observable<ConfigurationDto> {
    return this.http.get<ConfigurationDto>(API.configuration.get());
  }

  updateConfiguration(
    id: number,
    dto: Partial<ConfigurationDto>,
    file?: File,
  ): Observable<ApiResponse<ConfigurationDto>> {
    const formData = new FormData();

    // campos simples
    if (dto.commissionPercentage != null)
      formData.append('commissionPercentage', String(dto.commissionPercentage));

    if (dto.gracePeriodAtNode)
      formData.append('gracePeriodAtNode', dto.gracePeriodAtNode);

    if (dto.paymentAmountPerAccount != null)
      formData.append(
        'paymentAmountPerAccount',
        String(dto.paymentAmountPerAccount),
      );

    if (dto.maximumNumberOfBankAccounts != null)
      formData.append(
        'maximumNumberOfBankAccounts',
        String(dto.maximumNumberOfBankAccounts),
      );

    if (dto.companyEmail) formData.append('companyEmail', dto.companyEmail);

    if (dto.companyName) formData.append('companyName', dto.companyName);

    // phones (CLAVE)
    if (dto.phones) {
      formData.append('phones', JSON.stringify(dto.phones));
    }

    // file
    if (file) {
      formData.append('file', file);
    }

    return this.http.post<ApiResponse<ConfigurationDto>>(
      `${API.configuration.update(id)}`,
      formData,
    );
  }
  setLogo(url: string) {
    this.logoSubject.next(url);
  }

  getTerms(page: number, limit: number) {
    return this.http.get<any>(`${API.terms.get()}?page=${page}&limit=${limit}`);
  }

  getLatestTerms() {
    return this.http.get<any>(`${API.terms.latest()}`);
  }

  createTerms(content: string) {
    return this.http.post<any>(`${API.terms.create()}`, { content });
  }
}
